//所有状态码
const codes={
    success:"200",//成功
    BadRequest:"400",//客户端错误
    Unauthorized:"401",//未授权
    error:"500"//错误
  };
 export default codes